export const shouldShowPaymentModal = (project) => {
    // Lapsed-demo scouting reads off the gate's verdict; 'unpaid' stays a
    // displayStatus check (a distinct done-but-never-paid state). accessLevel is
    // compared inline to avoid a cycle with utils/capabilities.
    // 'preview' and 'unbuilt' deliberately fall through to false: those owners
    // already have full access and need a build, not a payment. A full-access
    // 'restoring_preview' falls through for the same reason; a lapsed demo in that
    // state still reads accessLevel 'scouting', so it keeps the same unlock offer
    // it has at 'locked' — the restoring state changes the panel, not the offer.
    return project.accessLevel === 'scouting' || project.displayStatus === 'unpaid';
};
